import COMMON_CONSTANTS from 'common/commonConstants';

const { DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID } = COMMON_CONSTANTS;

const DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION = {
  id: DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID,
  name: 'All Team Members',
  label: 'All Team Members',
  checked: true
};

const sortGroupOptions = (groups) => {
  // if "All Team Members" is checked, it will always be first
  // If "All Team Members" is not checked, it will be placed between checked and other unchecked groups
  const allTeamMembersOption = groups.find((g) => g.id === DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID);

  const allOtherGroups = groups.filter((g) => g.id !== DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID);
  const uncheckedGroups = allOtherGroups.filter((g) => !g.checked);
  const sortedUncheckedGroups = uncheckedGroups.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));
  const checkedGroups = allOtherGroups.filter((g) => g.checked);
  const sortedCheckedGroups = checkedGroups.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));

  return [
    allTeamMembersOption,
    ...sortedCheckedGroups,
    ...sortedUncheckedGroups
  ];
};

const getAllGroupOptions = (companyGroups, treeList) => {
  if (!companyGroups && !treeList.length) {
    return [DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION];
  }

  const teams = treeList
    .filter((node) => node.children.length)
    .map((node) => ({
      id: node.id,
      label: node.name,
      name: `Team ${node.name}`
    }));
  const allGroups = [...companyGroups, ...teams];
  const allGroupOptions = allGroups.map((g) => ({
    ...g,
    label: g.name,
    checked: false
  }));
  const allTeamMembersOption = {
    ...DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION,
    checked:
      allGroupOptions.length && allGroupOptions.every((opt) => !opt.checked)
  };
  const sortedOptions = sortGroupOptions([
    allTeamMembersOption,
    ...allGroupOptions
  ]);
  return sortedOptions;
};

const getCheckedGroupsIds = (groups = []) => {
  if (!groups.length) {
    return [];
  }

  const allTeamMembersOption = groups.find((group) => group.id === DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID);
  if (allTeamMembersOption.checked) {
    return [];
  }

  const formattedGroups = groups
    .filter((group) => group.checked)
    .map((group) => group.id);
  return formattedGroups;
};

export {
  DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION,
  getAllGroupOptions,
  sortGroupOptions,
  getCheckedGroupsIds
};
